/* Built In Imports */
/* External Imports */
import { Box, Flex, Text } from '@chakra-ui/react';
import Slider from 'react-slick';

/* Internal Imports */
/* Components */
import SectionTitle from '@components/Headings/SectionTitle';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';

/* Services */
/* Styles */
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

/* Services */

/**
 * Renders the Testimonials component.
 * @param {Object} testimonialsObj component.
 * @param {string} region - Region of page
 * @param {string} lang - Language of page
 * @returns {ReactElement} Testimonials component.
 */
const Testimonials = ({ testimonialsObj, myRef, region, lang }) => {
  const NextArrow = props => {
    // consoleLog('testimonial', testimonialsObj);
    const { onClick } = props;
    return (
      <Box
        pos="absolute"
        top="25%"
        zIndex="10"
        cursor="pointer"
        bgSize="20px"
        bgColor="transparent"
        border="0"
        borderRadius="100%"
        w="40px"
        h="40px"
        bgPos="center"
        bgRepeat="no-repeat"
        color="transparent"
        bgImage={`url(${config.staticPath}/assets/images/right-arrow.svg)`}
        right="-10px"
        onClick={onClick}
      ></Box>
    );
  };
  const PrevArrow = props => {
    const { onClick } = props;
    return (
      <Box
        pos="absolute"
        top="25%"
        zIndex="10"
        cursor="pointer"
        bgSize="20px"
        bgColor="transparent"
        border="0"
        borderRadius="100%"
        w="40px"
        h="40px"
        bgPos="center"
        bgRepeat="no-repeat"
        color="transparent"
        bgImage={`url(${config.staticPath}/assets/images/left-arrow.svg)`}
        left="-10px"
        onClick={onClick}
      />
    );
  };

  const settings = {
    dots: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 8000,
    slidesToShow: 2,
    slidesToScroll: 0,
    centerMode: false,
    infinite: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 834,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    customPaging: function (i) {
      return (
        <Text
          cursor="pointer"
          display="inline-block"
          w="10px"
          h="10px"
          m="0px 8px"
          bgColor="#cf4520"
          borderRadius="50%"
        ></Text>
      );
    },
  };

  return (
    <Box
      // ref={myRef}
      // float="left"
      w="100%"

      // p={{
      //   base: '65px 0px 50px 0px',
      //   sm: '120px 0px 50px 0px',
      //   md: '80px 20px',
      //   lg: '80px 65px',
      // }}
      // bgColor="#ffffff"
    // clipPath="polygon(100% 100%, 0% 100%, 0% 10%, 100% 0%)"
    >
      <SectionTitle titleObj={testimonialsObj?.title[0]} />
      <Box
        maxW="100%"
        m="0 auto"
        w="100%"
        overflow="hidden"
        p="0px 15px 30px 15px"
      >
        <Slider {...settings} m="0">
          {testimonialsObj?.testimonials?.map((data, i) => {
            return (
              <Box
                w={{
                  xl: '508px !important',
                  lg: '480px !important',
                  md: '383px !important',
                  sm: '328px !important',
                }}
                // width="calc((100% - 28px)/2)"
                mx={{ md: '28px !important', sm: 'auto', base: 'auto' }}
                background="#FFFFFF"
                padding={{ md: '30px', sm: '25px', base: '20px' }}
                marginBottom="20px"
              >
                <Flex
                  flexDir={{
                    lg: 'row',
                    md: 'column',
                    sm: 'column',
                    base: 'column',
                  }}
                >
                  <Box w="100px" m="0 auto">
                    <LazyLoadImageComponent
                      height={'100px'}
                      width={'100%'}
                      borderRadius={'100%'}
                      src={data?.photo?.url}
                      alt={data?.photo?.alt}
                      title={data?.photo?.title}
                    />
                  </Box>
                  <Box
                    display={{ md: 'block', sm: 'flex', base: 'flex' }}
                    flexDir={'column-reverse'}
                    width={{
                      md: 'calc(100% - 100px)',
                      sm: '100%',
                      base: '100%',
                    }}
                    paddingLeft="20px"
                    fontFamily="'FedraSansStd-book-i', sans-serif"
                    fontSize={{ sm: '16px', base: '16px', md: '16px' }}
                    lineHeight={{ sm: '26px', base: '26px', md: '26px' }}
                    fontWeight="400"
                    color="#5A5A5A"
                    textAlign={{ md: 'left', sm: 'center', base: 'center' }}
                    marginTop="10px"
                  >
                    <Box as="em">
                      {data?.testimonialText}
                    </Box>
                    <Flex
                      flexDir={{
                        md: 'column',
                        sm: 'column',
                        base: 'column',
                      }}
                    >
                      <Box
                        width={{ md: '100%', sm: '201px', base: '201px' }}
                        margin="0 auto"
                        fontFamily='"FedraSerifAStdBook", sans-serif'
                        fontSize="18px"
                        color="#28231E"
                        marginTop="20px"
                        fontWeight={'600'}
                        lineHeight={{
                          md: '27px',
                          sm: '23.76px',
                          base: '23.76px',
                        }}
                        // d="grid"
                        // placeContent={"center"}
                        textAlign={{ md: 'left', sm: 'center', base: 'center' }}
                      >
                        {data?.userName}
                        <Box
                          width={{ md: '100%', sm: '197px', base: '197px' }}
                          margin="0 auto"
                          fontFamily="'FedraSansStd-book', sans-serif"
                          fontSize="14px"
                          color="#AF1F22"
                          fontWeight={'500'}
                          textAlign={{ md: 'left', sm: 'center', base: 'center' }}
                          lineHeight={{
                            md: '21px',
                            sm: '19.6px',
                            base: '21.6px',
                          }}
                        >
                          {data?.userDescription}
                          <Flex
                            display={{ sm: 'flex', md: 'none', base: 'flex' }}
                            width="20px"
                            height={'25px'}                          
                            color={'white'}
                            borderRadius="100%"
                            margin={'26px auto 0 auto'}
                          >
                          <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_300_376)">
<path d="M0.746311 10.5083C0.471375 9.71142 0.436636 8.85181 0.646372 8.03552C0.892898 7.27877 1.32931 7.00328 2.41203 6.06729C4.41088 4.34467 5.41032 3.46179 5.58022 2.41627C5.77344 1.21475 5.09716 0.292039 5.34702 0.0928929C5.59687 -0.106254 6.77287 0.899438 7.47914 2.13747C9.07822 4.92552 9.0449 9.77141 6.67959 12.3271C6.36977 12.659 4.76402 14.3982 3.08165 13.834C1.49922 13.293 0.902888 11.0858 0.746311 10.5083Z" fill="#C5C5C5"/>
<path d="M10.781 11.1049C10.5178 10.5473 10.1147 9.68101 10.2546 8.6886C10.3645 7.90197 10.7443 7.55346 11.6505 6.4482C13.3162 4.40695 14.1424 3.36474 14.1291 2.28603C14.1291 1.07124 13.2829 0.294567 13.4961 0.0456336C13.7093 -0.2033 15.0419 0.596606 15.9514 1.70519C18.0102 4.17792 18.8264 8.9508 16.9508 11.8783C16.7076 12.2633 15.4283 14.2547 13.6693 13.9859C12.0103 13.7237 11.0375 11.6592 10.781 11.1049Z" fill="#C5C5C5"/>
</g>
<defs>
<clipPath id="clip0_300_376">
<rect width="17.5" height="14" fill="white" transform="matrix(-1 0 0 1 18 0)"/>
</clipPath>
</defs>
</svg>

                          </Flex>
                        </Box>
                      </Box>
                    </Flex>
                  </Box>
                </Flex>
              </Box>
            )
          })}
        </Slider>
      </Box>
    </Box>
  );
};

export default Testimonials;
